<template>
    <span></span>
</template>

<script>
export default {
    name: "Auth",
    props: {
        accountingToken: {
            type: String,
            default: null
        },
        accountingUrl: {
            type: String,
            default: null
        },
        signature: {
            type: String,
            default: null
        },
        companies: {
            type: Array,
            default: null
        }
    },
    mounted() {
        if (this.accountingToken) {
            this.$store.commit("auth/setAccountingToken", this.accountingToken);
        }

        if (this.accountingUrl) {
            this.$store.commit("auth/setAccountingUrl", this.accountingUrl);
        }

        if (this.companies) {
            this.$store.commit("auth/setCompanies", this.companies);
        }

        if (this.signature) {
            this.$store.commit("auth/setSignature", this.signature);
        }
    }
}
</script>

<style scoped>

</style>
